import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import actions from '../redux/actions/user';
import orderTransAction from '../redux/actions/order_transaction_history';
import orderAction from '../redux/actions/order_history';
import transAction from '../redux/actions/transactions';
import UserDetail from '../component/ListUser/UserDetail';

const mapStateToProps = (state) => ({
  users: state.user.users,
  userBalances: state.user.userBalances,
  coins: state.setting.coins,
  objCoinSettings: state.setting.objCoinSettings,
  coinSettings: state.setting.coinSettings,
  orderTrans: state.orderTrans,
  trans: state.transaction.trans,
  order: state.order,
  userInfo: state.user.userInfo,
  userLoginHistory: state.user.userLoginHistory,
  userAddressList: state.user.userAddressList,
  coins: state.setting.coins,
});

const mapDispatchToProps = (dispatch) => ({
  userListAction: (params, callback) => {
    dispatch(actions.userListAction(params, callback));
  },
  userBalancesAction: (params, callback) => {
    dispatch(actions.userBalancesAction(params, callback));
  },
  onFetchFilterTransactionHistoryAction: (params, callback) => {
    dispatch(orderTransAction.fetchFilterTransactionHistoryAction(params, callback));
  },
  onFetchUserOrderTransHistoryAction: (params, callback) => {
    dispatch(orderTransAction.fetchUserOrderTransHistoryAction(params, callback));
  },
  onFetchTransHistoryAction: (params, callback) => {
    dispatch(transAction.fetchTransHistoryAction(params, callback));
  },
  onFetchUserTransHistoryAction: (params, callback) => {
    dispatch(transAction.fetchUserTransHistoryAction(params, callback));
  },
  onFetchUserOrderHistory: (params, callback) => {
    dispatch(orderAction.fetchUserOrderHistory(params, callback));
  },
  userInfoAction: (params) => {
    dispatch(actions.userInfoAction(params));
  },
  onFetchUserOpenOrderHistoryAction: (params, callback) => {
    dispatch(orderAction.fetchUserOpenOrderHistory(params, callback));
  },
  onFetchUserLoginHitoryAction: (params, callback) => {
    dispatch(actions.userLoginHitoryAction(params, callback));
  },
  onUserListAddressAction: (params, callback) => {
    dispatch(actions.userListAddressAction(params, callback));
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserDetail));
